import { useEffect, useState } from 'react';
import {
  Button,
  Paper,
  Grid,
  Avatar,
  TextField,
  CardHeader,
  Typography,
  Box,
} from '@material-ui/core';
import { useStyles } from './style';
import DoctariModal from '../../components/Modal';
import { DropzoneArea } from 'material-ui-dropzone';
import { connect } from 'react-redux';
import { APPOINTMENTS } from '../../utils/urls';
import { userActionsTypes } from '../../redux/user/actions';
import { appointmentActionsTypes } from '../../redux/appointment/actions';
import AutocompleteInfo from '../../components/AutocompleteInfo';
import { useHistory, useLocation } from 'react-router';
import moment from 'moment';
import { AttachmentList } from './AttachmentList';
import Autocomplete from '@material-ui/lab/Autocomplete';

function AppointmentDetails({
  getUser,
  createAppointment,
  appointmentsData,
  session,
  userData,
  addUserInfo,
  deleteUserInfo,
  createInfo,
  deleteAppointment,
  updateAppointment,
  uploadAppointmentFiles,
  deleteAppointmentFile,
  deleteAttachmentMessages,
  updateAppointmentLight,
}) {
  const history = useHistory();
  const location = useLocation();
  const styles = useStyles();
  const [buttonClicked, setButtonClicked] = useState(false);
  const isProfessional = session.userType == 'doctor';
  const appointment = location.state.appointment;
  const [attachmentModalOpen, setAttachmentModalOpen] = useState(false);
  const [seeAttachmentsModalOpen, setSeeAttachmentsModalOpen] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [input, setInput] = useState(appointment.patient_appointment_reason);
  const [files, setFiles] = useState(appointment.files);
  const isAssistant = session.userType == 'assistant';
  const [doctorFullData, setDoctorFullData] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  const isDone = appointment.is_done;
  const [cancelAppointmentModal, setCancelAppointmentModal] = useState(false);
  const [feedback, setFeedback] = useState('');

  useEffect(() => {
    if (appointmentsData.success.uploadFiles) {
      files.push(...appointmentsData.success.uploadFiles);
      setFiles(files);
      setAttachmentModalOpen(false);
    }
    return () => deleteAttachmentMessages(true);
  }, [appointmentsData.success.uploadFiles]);

  useEffect(() => {
    if (
      ((appointmentsData.success.genericMessage &&
        appointmentsData.success.genericMessage ==
          'Appointment eliminado con exito') ||
        appointmentsData.success.genericMessage ==
          'Appointment actualizado con exito') &&
      buttonClicked
    ) {
      history.push(APPOINTMENTS);
    }
  }, [appointmentsData.success.genericMessage]);

  useEffect(() => {
    getUser(session.userType, session.id);
  }, []);

  useEffect(() => {
    if (userData.user) {
      setUserLoading(false);
    }
  }, [userData.user]);

  const { user, medications, allergies, diseases } = userData;

  const getUrlAndId = (type, isForDelete) => {
    let dataType = {
      id: 'medication_id',
      url: isForDelete ? 'delete_medication' : 'patient_medication',
    };
    if (type === 'diseases') {
      dataType = {
        id: 'disease_id',
        url: isForDelete ? 'delete_disease' : 'patient_disease',
      };
    } else if (type === 'allergies') {
      dataType = {
        id: 'allergie_id',
        url: isForDelete ? 'delete_allergie' : 'patient_allergie',
      };
    }
    return dataType;
  };

  const handleUserMedication = (isNew, med, isForDelete = false) => {
    const infoToUpdate = 'medications';
    const data = getUrlAndId(infoToUpdate, isForDelete);
    if (!isForDelete) {
      if (isNew) {
        createInfo(infoToUpdate, { name: med.name }, data);
      } else {
        addUserInfo(infoToUpdate, data, med);
      }
    } else {
      deleteUserInfo(infoToUpdate, data, med.id);
    }
  };

  const handleUserDisease = (isNew, disease, isForDelete = false) => {
    const infoToUpdate = 'diseases';
    const data = getUrlAndId(infoToUpdate, isForDelete);
    if (!isForDelete) {
      if (isNew) {
        createInfo(infoToUpdate, { name: disease.name }, data);
      } else {
        addUserInfo(infoToUpdate, data, disease);
      }
    } else {
      deleteUserInfo(infoToUpdate, data, disease.id);
    }
  };

  const handleUserAllergie = (isNew, allergie, isForDelete = false) => {
    const infoToUpdate = 'allergies';
    const data = getUrlAndId(infoToUpdate, isForDelete);
    if (!isForDelete) {
      if (isNew) {
        createInfo(infoToUpdate, { name: allergie.name }, data);
      } else {
        addUserInfo(infoToUpdate, data, allergie);
      }
    } else {
      deleteUserInfo(infoToUpdate, data, allergie.id);
    }
  };

  const addInformation = {
    handleUserMedication,
    handleUserAllergie,
    handleUserDisease,
  };

  const handleAttachmentsChange = (files) => {
    setAttachments(files);
    console.log(attachments);
    console.log(files);
  };

  const handleUploadAttachments = () => {
    const formDataAppointment = new FormData();
    for (let i = 0; i < attachments.length; i++) {
      console.log(`file${i}`);
      formDataAppointment.append(`file${i}`, attachments[i]);
    }
    const body = {
      files: formDataAppointment,
      appointmentId: appointment.id,
    };
    uploadAppointmentFiles(body);
  };

  const handleInputCHange = (e) => {
    setInput(e.target.value);
    console.log(e.target.value);
  };
  const handleDeleteAppointment = () => {
    setButtonClicked(true);
    deleteAppointment(appointment.id);
  };

  const handleUpdateAppointment = () => {
    setButtonClicked(true);
    let body = {
      patient_appointment_reason: input,
      diseases: user.diseases,
      medications: user.medications,
      allergies: user.allergies,
    };
    updateAppointment(appointment.id, body, true);
  };

  const handleChangeDoctor = (e, value) => {
    console.log('ESTE ES EL DOCTOR EN HANDLE ', value);
    if (value == null) {
      // console.log('este valor es null en handle');
      // clearSelectDoctor();
      // clearSchedules();
      setDoctorFullData(null);
      // console.log('seguro no es cero pero ', appointmentsData.schedules);
    } else {
      setDoctorFullData(value);
    }
  };

  const handleCancelAppointment = (e) => {
    e.preventDefault();
    setButtonClicked(true);
    let body = {
      status: 'cancelled',
      is_cancelled: true,
      cancellation_reason: feedback,
    };
    if (appointment.is_light) {
      updateAppointmentLight(appointment.id, body);
    } else {
      updateAppointment(appointment.id, body);
    }
  };

  return (
    <>
      {/* Add files modal */}
      <DoctariModal
        open={attachmentModalOpen}
        setOpen={(val) => setAttachmentModalOpen(val)}
        title={'Adjuntar estudios'}
      >
        <DropzoneArea
          useChipsForPreview={true}
          dropzoneText={
            'Haz click aquí o arrastra tus archivos para adjuntarlos'
          }
          onChange={(files) => handleAttachmentsChange(files)}
          onDelete={(file) => console.log(file)}
          clearOnUnmount={false}
          filesLimit={3}
          initialFiles={attachments}
          getFileAddedMessage={(file) => `${file} añadido`}
          getFileRemovedMessage={(file) => `${file} eliminado`}
          getFileLimitExceedMessage={(limit) =>
            `Limite de archivos excedido, el limite es de ${limit} archivos`
          }
        />
        <Button
          style={{ float: 'right', margin: '10px' }}
          variant="contained"
          color="primary"
          disabled={!attachments.length}
          onClick={handleUploadAttachments}
        >
          {!appointmentsData.loading ? 'Aceptar' : 'Cargando...'}
        </Button>
        <Button
          style={{ float: 'right', margin: '10px' }}
          color="red"
          onClick={() => {
            setAttachments([]);
            setAttachmentModalOpen(false);
          }}
          variant="outlined"
          /* color="primary" */
        >
          Cancelar
        </Button>
      </DoctariModal>
      {/* See files modal */}
      <DoctariModal
        open={seeAttachmentsModalOpen}
        setOpen={(val) => setSeeAttachmentsModalOpen(val)}
        title={'Archivos adjuntos'}
      >
        <AttachmentList
          files={files}
          setFiles={setFiles}
          deleteFile={deleteAppointmentFile}
        ></AttachmentList>
        <Button
          style={{ float: 'right', margin: '10px' }}
          variant="contained"
          color="primary"
          onClick={() => setSeeAttachmentsModalOpen(false)}
        >
          Aceptar
        </Button>
        <Button
          style={{ float: 'right', margin: '10px' }}
          color="red"
          onClick={() => setSeeAttachmentsModalOpen(false)}
          variant="outlined"
          /*  color="primary" */
        >
          Cancelar
        </Button>
      </DoctariModal>

      {/* Appointment's cancelation modal */}
      <DoctariModal
        open={cancelAppointmentModal}
        setOpen={(val) => setCancelAppointmentModal(val)}
        title={'Confirmación de cancelación'}
      >
        <Typography style={{ padding: '1rem' }}>
          ¿Estas seguro que deseas cancelar la consulta?
        </Typography>
        <form onSubmit={handleCancelAppointment}>
          <Box style={{ padding: '1rem' }}>
            <TextField
              required
              id="outlined-multiline-static"
              label="¿Por qué?"
              multiline
              style={{ width: '100%' }}
              rows="4"
              placeholder="Comentarios..."
              variant="outlined"
              onChange={(e) => setFeedback(e.target.value)}
            />
          </Box>
          <Box>
            <Button
              style={{ float: 'right', margin: '10px' }}
              variant="contained"
              color="primary"
              // disabled={!attachments.length}
              // onClick={() => }
              type="submit"
            >
              {!appointmentsData.loading ? 'Aceptar' : 'Cargando...'}
            </Button>

            <Button
              style={{ float: 'right', margin: '10px' }}
              color="red"
              onClick={() => {
                setCancelAppointmentModal(false);
              }}
              variant="outlined"
              /* color="primary" */
            >
              Cancelar
            </Button>
          </Box>
        </form>
      </DoctariModal>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid
          item
          xs={12}
          md={12}
          justifyContent="space-between"
          className={styles.menuContainer}
        >
          <h2 className={styles.title}>Detalles de la consulta</h2>
          <CardHeader
            avatar={
              <Avatar
                alt="Foto de perfil"
                src={
                  appointment.patient //TODO todos los chequeos de appointment.patient hay que sacarlos, quedaron appointment con patient= null por error, hay que limpiarlos
                    ? isProfessional
                      ? appointment.patient.profile_picture &&
                        appointment.patient.profile_picture.url
                      : appointment.doctor.profile_picture &&
                        appointment.doctor.profile_picture.url
                    : null
                }
                className={styles.avatar}
              />
            }
            title={
              isProfessional
                ? appointment.patient.full_name
                : appointment.doctor.full_name
            }
            subheader={
              isProfessional ? null : appointment.doctor.specialty.name
            }
          />
        </Grid>
        <Grid item className={styles.formConteiner}>
          <Paper elevation={8} style={{ padding: '40px 40px' }}>
            <Grid item container spacing={2} className={styles.testContainer}>
              <Grid className={styles.firstPaperContainer}>
                <p>
                  <b>Fecha de consulta:</b>
                  {` ${moment(appointment.date)
                    .tz(moment.tz.guess())
                    .format('YYYY-MM-DD HH:mm [hs]')}`}
                </p>
                <p>
                  Valor de la consulta:{' '}
                  <b>{appointment.price ? `$${appointment.price}` : '-'}</b>{' '}
                </p>
              </Grid>
              {isAssistant && (
                <Grid
                  // container
                  // direction="row"
                  item
                  xs={12}
                  md={12}
                  // style={{ padding: '1rem 0 0 3rem' }}
                >
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={
                      !userLoading
                        ? userData.user.doctors.filter((doctor) => {
                            return doctor.is_active;
                          })
                        : []
                    }
                    getOptionLabel={(option) => option.full_name}
                    sx={{ width: 300 }}
                    value={doctorFullData}
                    onChange={handleChangeDoctor}
                    renderInput={(params) => (
                      <TextField {...params} label="Seleccione un doctor" />
                    )}
                  />
                </Grid>
              )}
              <Grid item md={12} xs={12}>
                <TextField
                  disabled={isProfessional || isAssistant || isDone}
                  required
                  id="standard-basic"
                  label="Motivo de la consulta"
                  variant="standard"
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleInputCHange}
                  defaultValue={appointment.patient_appointment_reason}
                />
              </Grid>
              <Grid item md={6} xs={12} className={styles.paperGridItems}>
                <AutocompleteInfo
                  label={'Alergias'}
                  optionList={allergies}
                  valuesSelected={
                    isProfessional || isAssistant
                      ? appointment.allergies
                      : user
                      ? user.allergies
                      : []
                  }
                  isProfessional={isProfessional}
                  setNewValue={(allergie) => {
                    const isNew = true;
                    addInformation.handleUserAllergie(isNew, allergie);
                  }}
                  addValue={(allergie) => {
                    const isNew = false;
                    addInformation.handleUserAllergie(isNew, allergie);
                  }}
                  deleteValue={(allergie) => {
                    const isNew = false;
                    const isForDelete = true;
                    addInformation.handleUserAllergie(
                      isNew,
                      allergie,
                      isForDelete
                    );
                  }}
                  isAssistant={isAssistant}
                />
              </Grid>
              <Grid item md={6} xs={12} className={styles.paperGridItems}>
                <AutocompleteInfo
                  label={'Enfermedades'}
                  optionList={diseases}
                  valuesSelected={
                    isProfessional || isAssistant
                      ? appointment.diseases
                      : user
                      ? user.diseases
                      : []
                  }
                  isProfessional={isProfessional}
                  setNewValue={(disease) => {
                    const isNew = true;
                    addInformation.handleUserDisease(isNew, disease);
                  }}
                  addValue={(disease) => {
                    const isNew = false;
                    addInformation.handleUserDisease(isNew, disease);
                  }}
                  deleteValue={(disease) => {
                    const isNew = false;
                    const isForDelete = true;
                    addInformation.handleUserDisease(
                      isNew,
                      disease,
                      isForDelete
                    );
                  }}
                  isAssistant={isAssistant}
                />
              </Grid>
              <Grid item md={6} xs={12} className={styles.paperGridItems}>
                <AutocompleteInfo
                  label={'Medicamentos'}
                  optionList={medications}
                  valuesSelected={
                    isProfessional || isAssistant
                      ? appointment.medications
                      : user
                      ? user.medications
                      : []
                  }
                  isProfessional={isProfessional}
                  setNewValue={(med) => {
                    const isNew = true;
                    addInformation.handleUserMedication(isNew, med);
                  }}
                  addValue={(med) => {
                    const isNew = false;
                    addInformation.handleUserMedication(isNew, med);
                  }}
                  deleteValue={(med) => {
                    const isNew = false;
                    const isForDelete = true;
                    addInformation.handleUserMedication(
                      isNew,
                      med,
                      isForDelete
                    );
                  }}
                  isAssistant={isAssistant}
                />
              </Grid>
              <div className={styles.forthtPaperContainer}>
                <Grid item>
                  {!isProfessional && !isAssistant && (
                    <Button
                      variant="outlined"
                      className={styles.buttons}
                      color="primary"
                      style={{ marginRight: '10px' }}
                      onClick={() => setAttachmentModalOpen(true)}
                      disabled={isDone}
                    >
                      Adjuntar estudios
                    </Button>
                  )}
                  {!isProfessional && !isAssistant && (
                    <Button
                      variant="outlined"
                      className={styles.buttons}
                      color="primary"
                      style={{ marginRight: '10px' }}
                      onClick={() => setSeeAttachmentsModalOpen(true)}
                      disabled={isDone}
                    >
                      Ver adjuntos
                    </Button>
                  )}
                  <Button
                    variant="outlined"
                    className={styles.buttons}
                    color="primary"
                    onClick={() => setCancelAppointmentModal(true)}
                    disabled={isAssistant || isDone}
                  >
                    Cancelar consulta
                  </Button>
                  {!isProfessional && (
                    <Button
                      variant="contained"
                      className={styles.buttons}
                      color="primary"
                      onClick={handleUpdateAppointment}
                      disabled={isAssistant || isDone}
                    >
                      Guardar
                    </Button>
                  )}
                  {isProfessional && (
                    <Button
                      variant="contained"
                      className={styles.buttons}
                      color="primary"
                      onClick={() => {
                        let pageName;
                        if (appointment.is_light) {
                          pageName =
                            process.env.REACT_APP_VIDEO_URL +
                            'appointment/' +
                            appointment.id +
                            '/?idUser=' +
                            session.id +
                            '&token=' +
                            session.accessToken +
                            '&light=1';
                        } else {
                          pageName =
                            process.env.REACT_APP_VIDEO_URL +
                            'appointment/' +
                            appointment.id +
                            '/?idUser=' +
                            session.id +
                            '&token=' +
                            session.accessToken;
                        }
                        window.location.href = pageName;
                      }}
                    >
                      Aceptar e ir
                    </Button>
                  )}
                </Grid>
              </div>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

const mapStateToProps = ({ session, user, appointments }) => {
  return {
    session,
    userData: user,
    appointmentsData: appointments,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getUser: (type, id) =>
    dispatch({
      type: userActionsTypes.GET_USER,
      payload: { type, id },
    }),
  addUserInfo: (type, data, newValue) =>
    dispatch({
      type: userActionsTypes.ADD_INFO_USER,
      payload: { type, data, newValue },
    }),
  createInfo: (type, body, data) =>
    dispatch({
      type: userActionsTypes.CREATE_INFORMATION,
      payload: { type, body, data },
    }),
  deleteUserInfo: (type, data, valueId) =>
    dispatch({
      type: userActionsTypes.DELETE_INFO_USER,
      payload: { type, data, valueId },
    }),
  createAppointment: (
    scheduleId,
    reason,
    doctor,
    patient,
    token,
    allergiesObjects,
    medicationsObjects,
    diseasesObjects
  ) =>
    dispatch({
      type: appointmentActionsTypes.CREATE_APPOINTMENT,
      payload: {
        scheduleId,
        reason,
        doctor,
        patient,
        token,
        allergiesObjects,
        medicationsObjects,
        diseasesObjects,
      },
    }),

  updateAppointment: (id, body, isInformation) =>
    dispatch({
      type: appointmentActionsTypes.UPDATE_APPOINTMENT,
      payload: {
        id,
        body,
        isInformation,
      },
    }),
  updateAppointmentLight: (id, body) =>
    dispatch({
      type: appointmentActionsTypes.UPDATE_APPOINTMENT_LIGHT,
      payload: { id, body },
    }),
  uploadAppointmentFiles: (body) =>
    dispatch({
      type: appointmentActionsTypes.UPLOAD_APPOINTMENT_FILES,
      payload: { body },
    }),
  deleteAppointment: (appointmentId) =>
    dispatch({
      type: appointmentActionsTypes.DELETE_APPOINTMENT,
      payload: {
        appointmentId,
      },
    }),
  deleteAppointmentFile: (fileId) =>
    dispatch({
      type: appointmentActionsTypes.DELETE_APPOINTMENT_FILE,
      payload: {
        fileId,
      },
    }),
  deleteAttachmentMessages: () =>
    dispatch({
      type: appointmentActionsTypes.DELETE_ATTACHMENT_MESSAGES,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentDetails);
